module.exports = __webpack_public_path__ + "static/img/planche.3716094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/planche.jpg
// module id = 32
// module chunks = 0